import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles(() => ({
  title: {
    fontWeight: 500,
    letterSpacing: "0.15px",
  },
}));
